import { Pipe, PipeTransform } from '@angular/core';
import {
  TimeBankTypeEnum,
  TimeBankTypeInformation,
} from '@qaroni-app/time-bank/types/time-bank-type.enum';

@Pipe({
  name: 'timeBankTypeName',
  standalone: false,
})
export class TimeBankTypeNamePipe implements PipeTransform {
  transform(value: TimeBankTypeEnum): string {
    if (
      value &&
      Object.prototype.hasOwnProperty.call(TimeBankTypeInformation, value)
    ) {
      return TimeBankTypeInformation[value].name;
    }

    return value;
  }
}
